
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.857 12.138a5.017 5.017 0 10-5.713 0c-5.726 1.25-6.062 4.42-6.144 6.306a1.031 1.031 0 00.67.987c.988.259 2.977.62 8.33.62s7.342-.362 8.329-.62a1.032 1.032 0 00.67-.987c-.081-1.886-.417-5.056-6.142-6.306z"}})])
          )
        }
      }
    